<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low"
            width="table-action-menu--only-two">
            <edit-button :url="route('tenant.clients.courses.edit', {'client': clientId, 'course': data.id})" grid="table-action-cell--grid-1of2"></edit-button>

            <delete-button
                :url="route('tenantapi.clients.unassign', {'client' : clientId, 'course': data.id})"
                :confirmTitle="trans('clients.note.unassign_title')"
                :confirmText="trans('clients.note.unassign_message')"
                :errorFlashMessage="trans('clients.flash.not_deleted')"
                :deleteId="data.id"
                grid="table-action-cell--grid-1of2"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'clientId'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
